module.exports = __webpack_public_path__ + "static/klearMap-0d54bbad83265737d28fa51fa7eb256b.svg";